import { autocompleteClasses, ComponentsOverrides, Theme } from "@mui/material";
import { Autocomplete as MuiAutocomplete } from "@mui/material";

const StyledAutocomplete = MuiAutocomplete;

/**
 * @description Must be imported into global theme due to popper being in a portal.
 */
export const autocompleteStyleOverrides: ComponentsOverrides<Theme>["MuiAutocomplete"] = {
  paper: ({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
  }),
  popper: ({ theme }) => ({
    [`& .${autocompleteClasses.groupLabel}`]: { color: theme.palette.primary.main },
    [`& .${autocompleteClasses.listbox}`]: {
      [`& .${autocompleteClasses.option}`]: {
        fontSize: "14px",
        lineHeight: "20px",
        padding: theme.spacing(1, 1.5),
        color: theme.palette.primary.main,
        "&.Mui-focused": {
          color: theme.palette.primary.main,
        },
        '&[aria-selected="true"]': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.common.white,
        },
        '&[aria-selected="true"].Mui-focused': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.common.white,
        },
      },
    },
  }),
};

export default StyledAutocomplete;
